import React from 'react'
import './contact.css'
import { FaWhatsapp, FaFacebookF, FaTelegramPlane } from "react-icons/fa"

const Contact = () => {
  return (
    <div className="contact" id="contact">
      <div className="container">

        <form>
          <input type="text" placeholder="الاٍسم" />
          <input type="text" placeholder="الاٍيميل" />
          <input type="file" />
          <textarea placeholder="الرسالة" rows="6"></textarea>
          <button type="submit">إرسال</button>
        </form>

        {/* Social Icons */}
        <div className="socials">
          <a href="https://wa.me/201000000000" target="_blank" rel="noreferrer">
            <FaWhatsapp />
          </a>
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <FaFacebookF />
          </a>
          <a href="https://t.me/username" target="_blank" rel="noreferrer">
            <FaTelegramPlane />
          </a>
        </div>

      </div>
    </div>
  )
}

export default Contact
